export const getFuelVolumeUnit = (source) => {
  if (!source) return null;
  return source.fuel_volume_unit || source.volume_unit || source.unit || null;
};

export const hasConfiguredFuelVolumeUnit = (source) => Boolean(getFuelVolumeUnit(source));

export const getFuelVolumeUnitLabel = (source) => {
  const unit = getFuelVolumeUnit(source);
  if (!unit) return 'Litres';
  return unit.name || unit.code || 'Configured Unit';
};

export const getFuelVolumeUnitShortLabel = (source) => {
  const unit = getFuelVolumeUnit(source);
  if (!unit) return 'L';
  return unit.name || unit.code || 'Unit';
};

export const litresToConfiguredUnit = (litres, source) => {
  const unit = getFuelVolumeUnit(source);
  const rate = Number(unit?.conversion_rate_to_litre);
  const value = Number(litres);
  if (!unit || !Number.isFinite(value) || !Number.isFinite(rate) || rate <= 0) return null;
  return value / rate;
};

export const formatVolumeValue = (litres, configuredValue, source) => {
  const litreValue = Number(litres);
  if (!Number.isFinite(litreValue)) return '0 L';

  const litreText = litreValue ? `${litreValue.toFixed(2)} L` : '0 L';
  let configuredNumber = Number(configuredValue);
  if (!Number.isFinite(configuredNumber) && hasConfiguredFuelVolumeUnit(source)) {
    configuredNumber = litresToConfiguredUnit(litreValue, source);
  }
  if (!Number.isFinite(configuredNumber)) return litreText;

  const configuredLabel = hasConfiguredFuelVolumeUnit(source)
    ? getFuelVolumeUnitShortLabel(source)
    : 'gallons';
  return `${litreText} (${configuredNumber.toFixed(2)} ${configuredLabel})`;
};
